export const getReportTargetOpenId = (report?: Pick<IReport, 'creator_name' | 'creator_name_en'> | null): string => {
  const selectedOpenId = report?.creator_name_en?.trim() || '';
  if (selectedOpenId) {
    return selectedOpenId;
  }

  const creatorName = report?.creator_name?.trim() || '';
  if (!creatorName.includes('(')) {
    return '';
  }

  return creatorName.split('(')?.[0]?.trim() || '';
};

export const getReportMutationParams = (
  adminMode: boolean,
  report?: Pick<IReport, 'creator_name' | 'creator_name_en'> | null,
): IReportMutationParams => {
  return {
    admin_mode: adminMode,
    target_open_id: getReportTargetOpenId(report),
  };
};
